import React, { useEffect } from "react";
import { Terminal } from "lucide-react";
import OutputConsole from "./OutputConsole";
import PreviewPanel from "./PreviewPanel";

const TABS = [
  { id: "output", label: "Output" },
  { id: "preview", label: "Preview" },
];

export default function RightPanel({
  tab,
  onTabChange,
  result,
  isRunning,
  errorText,
  language,
  previewUrl,
  runStamp,
}) {
  const previewEnabled = language === "html";

  // If user is on Preview tab but switches away from html, snap to Output.
  useEffect(() => {
    if (tab === "preview" && !previewEnabled) onTabChange?.("output");
  }, [tab, previewEnabled, onTabChange]);

  return (
    <div className="flex h-full flex-col bg-ide-panel2 border-l border-ide-border">
      <div className="flex items-center border-b border-ide-border bg-ide-panel">
        {TABS.map((t) => {
          const isPreview = t.id === "preview";
          const disabled = isPreview && !previewEnabled;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              onClick={() => !disabled && onTabChange?.(t.id)}
              className={
                "relative px-4 py-2 text-sm border-r border-ide-border transition-all duration-150 " +
                (active
                  ? "text-ide-text bg-ide-panel2 font-medium"
                  : disabled
                  ? "text-ide-mute opacity-40 cursor-not-allowed"
                  : "text-ide-mute hover:text-ide-text hover:bg-ide-surface")
              }
              title={
                disabled ? "Switch to HTML to preview" : `Show ${t.label}`
              }
              disabled={disabled}
            >
              {t.label}
              {active && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-ide-accent to-ide-accent2 rounded-full" />
              )}
            </button>
          );
        })}
        <div className="ml-auto px-3 text-[11px] uppercase tracking-wider text-ide-mute flex items-center gap-1.5">
          <Terminal className="h-3.5 w-3.5" />
          {tab === "output" ? "console" : "iframe"}
        </div>
      </div>

      <div className="flex-1 min-h-0">
        {tab === "output" ? (
          <OutputConsole
            result={result}
            isRunning={isRunning}
            errorText={errorText}
          />
        ) : (
          <PreviewPanel
            enabled={previewEnabled}
            previewUrl={previewUrl}
            runStamp={runStamp}
          />
        )}
      </div>
    </div>
  );
}
